import { apiFuns } from "sw-hic";
let { genStandard, post } = apiFuns;
let api = {
  Report: genStandard("report", "/api/report"),
  DbCon: {
    ...genStandard("dbCon", "/api/report"),
    testSql:(para)=> post('/api/report/dbCon/test', para),
  },
  PrintTemplate: genStandard("printTemplate", "/api/md"),
};
export default api;
